
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"#fff","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_4870_134)"}},[_c('path',{attrs:{"d":"M6.167 0h-5C.523 0 0 .523 0 1.167v3c0 .643.523 1.166 1.167 1.166h5c.643 0 1.166-.523 1.166-1.166v-3C7.333.523 6.81 0 6.167 0zM6.167 6.667h-5C.523 6.667 0 7.19 0 7.833v7C0 15.477.523 16 1.167 16h5c.643 0 1.166-.523 1.166-1.167v-7c0-.643-.523-1.166-1.166-1.166zM14.833 10.667h-5c-.643 0-1.166.523-1.166 1.166v3c0 .644.523 1.167 1.166 1.167h5c.644 0 1.167-.523 1.167-1.167v-3c0-.643-.523-1.166-1.167-1.166zM14.833 0h-5C9.19 0 8.667.523 8.667 1.167v7c0 .643.523 1.166 1.166 1.166h5c.644 0 1.167-.523 1.167-1.166v-7C16 .523 15.477 0 14.833 0z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_4870_134"}},[_c('path',{attrs:{"d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    